/* ===================================================================
   useEntryModel() -- React binding for the onboarding entry-model A/B flag
   (Phase 5, spec §7). Resolves the active arm once (stable for the page load)
   and fires the experiment-exposure event exactly ONCE per load, no matter how
   many components read the flag.

   Consumers:
     - App.tsx RequireSubscription -- gate only in 'front_door_wall'.
     - PostActivationCardAsk        -- the post-activation card ask (reverse arm).

   The resolver is synchronous (localStorage/env), so the value is stable across
   renders; useMemo keeps the reference stable and the module-level guard makes
   the analytics fire idempotent.
   =================================================================== */
import { useEffect, useMemo } from 'react';
import {
  resolveEntryModel,
  trackEntryModelExposure,
  type EntryModel,
} from '../config/entryModel';

/* Module-level so it survives across every mount in this page load -- the
   exposure event fires once total, not once per component that reads the arm. */
let exposureFired = false;

export function useEntryModel(): EntryModel {
  const model = useMemo(() => resolveEntryModel(), []);

  useEffect(() => {
    if (exposureFired) return;
    exposureFired = true;
    trackEntryModelExposure(model, 'app_boot');
  }, [model]);

  return model;
}
